/**
 * Tour steps configuration for VMASS POS
 * Defines the onboarding steps for different pages
 */

// Dashboard Tour Steps
export const dashboardSteps = [
  {
    target: "body",
    content:
      "🎉 Chào mừng bạn đến với VMASS POS! Hãy cùng tìm hiểu giao diện bán hàng qua các bước hướng dẫn sau.",
    placement: "center",
    disableBeacon: true,
    title: "Chào mừng đến VMASS!",
  },
  {
    target: ".list-unstyled",
    content:
      "📋 Đây là thanh điều hướng chính (Sidebar trái). Bạn có thể truy cập tất cả các tính năng như: Bán hàng, Sản phẩm, Khách hàng, Báo cáo... từ đây.",
    placement: "right",
    title: "Menu điều hướng",
  },
  {
    target: ".simple-icon-menu",
    content:
      "📊 Đây là Sidebar phải - Dùng để tạo phân quyền cho tài khoản, tạo tài khoản nhân viên và liên kết đại lý/chi nhánh.",
    placement: "left",
    title: "Quản lý đơn hàng",
  },
  {
    target: ".search",
    content:
      "🔍 Khu vực tìm kiếm nhanh. Nhập tên sản phẩm hoặc mã barcode để tìm kiếm nhanh chóng.",
    placement: "bottom",
    title: "Tìm kiếm sản phẩm",
  },
  {
    target: ".navbar-right",
    content:
      "⚙️ Khu vực quản lý chức năng: Thông báo, tin nhắn, cài đặt tài khoản và đăng xuất.",
    placement: "bottom",
    title: "Thanh công cụ",
  },
  {
    target: "#table-chairs",
    content:
      "🛒 Khu vực hiển thị danh sách sản phẩm. Nhấn vào sản phẩm để thêm vào đơn hàng. Bạn có thể lọc theo danh mục hoặc chế độ hiển thị.",
    placement: "right",
    title: "Danh sách sản phẩm",
  },
  {
    target: ".dashboard-right",
    content:
      "📝 Khu vực quản lý đơn hàng - hiển thị các sản phẩm đang được đặt, điều chỉnh số lượng, áp dụng giảm giá và thanh toán.",
    placement: "left",
    title: "Quản lý đơn hàng",
  },
];

// Products Page Tour Steps
export const productSteps = [
  {
    target: "body",
    content:
      "📦 Đây là trang Quản lý Sản phẩm. Bạn có thể thêm, sửa, xóa và quản lý tất cả sản phẩm tại đây.",
    placement: "center",
    disableBeacon: true,
    title: "Quản lý Sản phẩm",
  },
  {
    target: ".tour-button-add",
    content:
      "➕ Nhấn nút này để thêm sản phẩm mới. Bạn có thể thêm từng sản phẩm hoặc import hàng loạt từ file Excel.",
    placement: "left",
    title: "Thêm sản phẩm mới",
  },
  {
    target: ".search",
    content: "🔍 Tìm kiếm sản phẩm theo tên, mã SKU hoặc barcode tại đây.",
    placement: "bottom",
    title: "Tìm kiếm sản phẩm",
  },
  {
    target: ".tour-button-filter",
    content:
      "🎯 Khu vực lọc sản phẩm theo danh mục, trạng thái hoặc các thuộc tính khác để dễ dàng quản lý.",
    placement: "left",
    title: "Bộ lọc sản phẩm",
  },
  {
    target: ".tour-list-products",
    content:
      "📋 Danh sách sản phẩm được hiển thị tại đây. Nhấn vào sản phẩm để xem chi tiết hoặc chỉnh sửa.",
    placement: "right",
    title: "Danh sách sản phẩm",
  },
];

// Analytics/Reports Page Tour Steps
export const analyticsSteps = [
  {
    target: "body",
    content:
      "📊 Đây là trang Báo cáo & Thống kê. Xem tổng quan doanh thu, sản phẩm bán chạy và các phân tích kinh doanh.",
    placement: "center",
    disableBeacon: true,
    title: "Báo cáo & Thống kê",
  },
  {
    target: ".tour-tab-analytics",
    content:
      "🔄 Chuyển đổi giữa các loại báo cáo: Tổng quan, Doanh thu, Sản phẩm, Khách hàng, Nhân viên...",
    placement: "top",
    title: "Chuyển đổi báo cáo",
  },
  {
    target: "#datePicker",
    content:
      "📅 Chọn khoảng thời gian để xem báo cáo. Có thể chọn nhanh: Hôm nay, Tuần này, Tháng này hoặc tùy chỉnh.",
    placement: "left",
    title: "Chọn khoảng thời gian",
  },
  {
    target: ".react-select__control",
    content:
      "🏪 Nếu bạn có nhiều chi nhánh, có thể chọn cửa hàng cụ thể hoặc xem tổng hợp tất cả.",
    placement: "right",
    title: "Chọn cửa hàng",
  },
  {
    target: ".progress-banner",
    content:
      "📈 Khu vực hiển thị nội dung báo cáo với biểu đồ, bảng thống kê và các chỉ số quan trọng.",
    placement: "top",
    title: "Nội dung báo cáo",
  },
];

// Helper to get tour name based on current path
export const getTourNameByPath = (pathname) => {
  if (
    pathname.includes("/dashboards") ||
    pathname === "/app" ||
    pathname === "/app/"
  ) {
    return "dashboard";
  }
  if (pathname.includes("/product")) {
    return "product";
  }
  if (pathname.includes("/analytics") || pathname.includes("/report")) {
    return "analytics";
  }
  return null;
};

// Helper to get steps based on tour name
export const getStepsByTourName = (tourName) => {
  switch (tourName) {
    case "dashboard":
      return dashboardSteps;
    case "product":
      return productSteps;
    case "analytics":
      return analyticsSteps;
    default:
      return [];
  }
};
